<template lang="pug">
  aside.sidebar(v-show="this.sidebar")
    .sidebar__top(v-if="windowWidth < 1200")
      router-link(to='/activity/preview').btn Посмотреть виджет
      a(href='#' @click.prevent="onSidebar").sidebar__close
        svgicon(name='close')
    .sidebar__item
      .sidebar__title Статистика
      router-link(to="/activity/summary").sidebar__link Сводка
      router-link(to="/activity/sales").sidebar__link Продажи
      a(href='#').sidebar__link Просмотры

    .sidebar__item
      .sidebar__title Билеты
      router-link(to="/activity/tickets").sidebar__link Билеты
      a(href='#').sidebar__link Пригласительные
      a(href='#').sidebar__link Дизайн билетов

    .sidebar__item
      .sidebar__title Заказы
      router-link(to="/activity/orders").sidebar__link Заказы
      a(href='#').sidebar__link Возврат билетов

    .sidebar__item
      .sidebar__title Маркетинг
      router-link(to="/activity/promo").sidebar__link Промокоды
      router-link(to="/activity/integration").sidebar__link Интеграции
      router-link(to="/activity/preview").sidebar__link Предпросмотр

    .sidebar__item
      .sidebar__title Настройки
      router-link(to="/activity/MainInformation").sidebar__link Основная информация
      router-link(to="/activity/SettingActivity").sidebar__link Настройки

    .sidebar__item
      .sidebar__title Сканирование билетов
      a(href='#').sidebar__link Основная информация
      router-link(to="/activity/SettingScan").sidebar__link Настройки
      router-link(to="/activity/NewField").sidebar__link Новое поле

</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  data: function() {
    return {
      windowWidth: null,
    }
  },
  watch: {
    $route() {
      if(this.windowWidth < 1200) {
        this.onSidebar(false)
      }
    }
  },
  mounted() {
    this.sortActivities,
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    ...mapMutations([
      'onSidebar',
    ]),
    arhiveBlock() {
      return this.arhive = !this.arhive
    },
    isPin(activity) {
      return activity.pin = !activity.pin, this.sortActivities;
    },
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
      this.onSidebar(this.windowWidth)
    },
  },
  computed:{
    ...mapGetters([
      'sidebar',
    ]),
  },
}
</script>

<style lang="scss">
.sidebar{
  width: 200px;
  background-color: #e7f1f8;
  padding: 40px;
  flex-shrink: 0;
  &__item{
    margin-bottom: 40px;
  }
  &__title{
    color: #9398a2;
    font-size: 14px;
    margin-bottom: 20px;
  }
  &__link{
    display: block;
    color: #161616;
    font-size: 16px;
    text-decoration: none;
    position: relative;
    margin-bottom: 20px;
    &:hover{
      color: #008cff;
    }
    &.router-link-active{
      font-weight: 700;
      &:before{
        content: '';
        position: absolute;
        top: 6px;
        left: -15px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: #008cff;
      }
    }
  }
}

@media (max-width: 1199px) {
  .sidebar{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 11;
    box-sizing: border-box;
    padding-bottom: 20px;
    padding-right: 20px;
    .sidebar__item:last-child{
      margin-bottom: 0px;
    }
    &__top{
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
    }
    &__close{
      width: 30px;
      height: 30px;
      color: #161616;
      display: flex;
      justify-content: center;
      align-items: center;
      .svg-icon{
        width: 19px;
        height: 19px;
        display: block;
      }
    }
  }
}
</style>
